import type { GameManual } from '../../types';
import { projektGajaChapters, projektGajaFirstGame } from './content';

export const projektGajaManual: GameManual = {
  chapters: projektGajaChapters,
  firstGameSteps: projektGajaFirstGame,
  addons: [
  {
    "id": "lost-fleet",
    "name": "Zaginiona Flota"
  }
],
};

export * from './content';
export * from './blockers';
export * from './faq';
export * from './glossary';
export * from './guided';
export * from './quickReference';
export * from './commonMistakes';
export * from './scoring';
export * from './components';
export * from './icons';
export * from './search';
export * from './validate';
